import Big from "big.js"

type LineTaxValidationConfig = {
  opcoSlug: string
  threshold: Big
}

export const lineTaxValidationThresholds: Array<LineTaxValidationConfig> = [
  {
    opcoSlug: "sunrise",
    threshold: new Big(1.0),
  },
]
